import { RJSFSchema } from "@rjsf/utils";

export const cueFormSchema: RJSFSchema = {
  type: "object",
  "x-logo": "/657507_tmpl_head_60db3e2024ea6.png",
  title: "Contact Us",
  required: ["firstName", "lastName", "email", "companyNameOrGroupNumber", "howCanWeHelp", "howDidYouHear"],
  properties: {
    firstName: {
      type: "string",
      title: "First Name",
    },
    lastName: {
      type: "string",
      title: "Last Name",
    },
    email: {
      type: "string",
      title: "Email Address",
      format: "email",
    },
    phone: {
      type: "string",
      title: "Phone (Optional)",
    },
    companyNameOrGroupNumber: {
      type: "string",
      title: "Company Name or Group Number",
    },
    blueSeparator: {
      type: "null",
      title: "",
    },
    howCanWeHelp: {
      type: "string",
      title: "Please describe how we can help",
    },
    howDidYouHear: {
      type: "string",
      title: "How did you hear about us?",
    },
  },
};
